// tiny helper: safely parse JSON (handles empty body and bad JSON)
async function safeJson(res) {
  const text = await res.text(); // never throws
  if (!text) return null;
  try { return JSON.parse(text); } catch { return text; } // fallback to raw text
}

export async function fetchJson(url, token, opts = {}) {
  const { headers, signal, ...rest } = opts;

  const res = await fetch(url, {
    method: "GET",
    ...rest,
    signal,
    headers: {
      Authorization: token ? `Bearer ${token}` : undefined,
      "Content-Type": "application/json",
      ...(headers || {}),
    },
  });

  // Normalize error body for better debugging
  if (!res.ok) {
    const body = await safeJson(res);
    const msg = `${(rest.method || "GET").toUpperCase()} ${url} -> ${res.status}` +
      (body ? ` | ${typeof body === "string" ? body : JSON.stringify(body)}` : "");
    throw new Error(msg);
  }

  if (res.status === 204) return null;
  return safeJson(res); // robust even if server returns empty body
}

export async function fetchJsonAuth(url, token, opts = {}) {
  const { headers, signal, ...rest } = opts;

  const res = await fetch(url, {
    method: "GET",
    ...rest,
    signal,
    headers: {
      Authorization: token ? `Bearer ${token}` : undefined,
      ...(headers || {}),
    },
  });

  if (!res.ok) {
    const body = await safeJson(res);
    const msg = `${url} -> ${res.status}` +
      (body ? ` | ${typeof body === "string" ? body : JSON.stringify(body)}` : "");
    throw new Error(msg);
  }

  if (res.status === 204) return null;
  return safeJson(res);
}
